import { Host, h } from "@stencil/core";
const mapDropdownAlignToChWindowAlign = {
    OutsideStart: "outside-start",
    InsideStart: "inside-start",
    Center: "center",
    InsideEnd: "inside-end",
    OutsideEnd: "outside-end"
};
const EXPANDABLE_BUTTON_ID = "expandable-button";
const SECTION_ID = "section";
const DROPDOWN_ITEM_TAG_NAME = "ch-dropdown-item";
const DROPDOWN_ITEM_SELECTOR = `:scope > ${DROPDOWN_ITEM_TAG_NAME}`;
// Keys
const TAB_KEY = "Tab";
export class ChDropDown {
    constructor() {
        this.expanded = false;
        this.expandedWithHover = false;
        this.buttonLabel = "Show options";
        this.expandBehavior = "ClickOrHover";
        this.nestedDropdown = false;
        this.openOnFocus = false;
        this.position = "Center_OutsideEnd";
    }
    keyEventsDictionary = {
        ArrowDown: (event) => {
            event.preventDefault();
            if (!this.currentFocusedItem) {
                this.focusFirstDropDownItem();
                return;
            }
            const nextDropDownItem = this.findNextDropDownItemSibling();
            if (nextDropDownItem) {
                // This is wrong, it should call the focusElement Method. StencilJS bug?
                nextDropDownItem.handleFocusElement();
            }
        },
        ArrowUp: (event) => {
            event.preventDefault();
            if (!this.currentFocusedItem) {
                this.focusFirstDropDownItem();
                return;
            }
            const previousDropDownItem = this.findPreviousDropDownItemSibling();
            if (previousDropDownItem) {
                // This is wrong, it should call the focusElement Method. StencilJS bug?
                previousDropDownItem.handleFocusElement();
            }
        },
        Escape: () => {
            this.closeDropdown();
            this.returnFocusToButton();
        }
    };
    showHeader = false;
    showFooter = false;
    firstExpanded = false;
    /**
     * Determine the current dropdown-item that is focused
     */
    currentFocusedItem;
    // Refs
    expandableButton;
    el;
    /**
     * Fired when the visibility of the dropdown section is changed
     */
    expandedChange;
    handleExpandedChange(newExpandedValue) {
        if (newExpandedValue) {
            this.currentFocusedItem = undefined;
            // Click
            document.body.addEventListener("click", this.closeDropdownWhenClickingOutside, {
                capture: true
            });
            // Keyboard events
            if (!this.nestedDropdown) {
                document.body.addEventListener("keydown", this.handleKeyDownEvents, {
                    capture: true
                });
            }
            document.body.addEventListener("keyup", this.handleKeyUpEvents, {
                capture: true
            });
        }
        else {
            // Click
            document.body.removeEventListener("click", this.closeDropdownWhenClickingOutside, {
                capture: true
            });
            // Keyboard events
            if (!this.nestedDropdown) {
                document.body.removeEventListener("keydown", this.handleKeyDownEvents, {
                    capture: true
                });
            }
            document.body.removeEventListener("keyup", this.handleKeyUpEvents, {
                capture: true
            });
        }
    }
    handleActionClick() {
        this.closeDropdown();
        // @todo This behavior must be specified by a property
        // this.returnFocusToButton();
    }
    handleDropDownItemFocusChange(event) {
        this.currentFocusedItem = event.target;
    }
    focusFirstDropDownItem() {
        this.currentFocusedItem = this.el.querySelector(DROPDOWN_ITEM_SELECTOR);
        if (this.currentFocusedItem) {
            this.currentFocusedItem.handleFocusElement();
        }
    }
    findNextDropDownItemSibling() {
        let nextSibling = this.currentFocusedItem
            .nextElementSibling;
        while (nextSibling &&
            nextSibling.tagName.toLowerCase() !== DROPDOWN_ITEM_TAG_NAME) {
            nextSibling = nextSibling.nextElementSibling;
        }
        return nextSibling;
    }
    findPreviousDropDownItemSibling() {
        let previousSibling = this.currentFocusedItem
            .previousElementSibling;
        while (previousSibling &&
            previousSibling.tagName.toLowerCase() !== DROPDOWN_ITEM_TAG_NAME) {
            previousSibling =
                previousSibling.previousElementSibling;
        }
        return previousSibling;
    }
    closeDropdown = () => {
        this.closeDropdownWithHover();
        this.expanded = false;
        this.expandedChange.emit(false);
    };
    closeDropdownWithHover = () => {
        this.expandedWithHover = false;
        // If the control was not expanded with focus
        if (!this.expanded) {
            this.expandedChange.emit(false);
        }
    };
    /**
     * Returns focus to the expandable button when closing the dropdown. Only
     * works if `openOnFocus = "false"`
     */
    returnFocusToButton() {
        if (!this.openOnFocus && !this.nestedDropdown) {
            this.expandableButton.focus();
        }
    }
    closeDropdownWhenClickingOutside = (event) => {
        if (event.composedPath().find(el => el === this.el) === undefined) {
            this.closeDropdown();
        }
    };
    handleKeyDownEvents = (event) => {
        const keyEventHandler = this.keyEventsDictionary[event.code];
        if (keyEventHandler) {
            keyEventHandler(event);
        }
    };
    /**
     * Check if the next focused element is a child element of the dropdown
     * control.
     */
    handleKeyUpEvents = (event) => {
        if (event.code !== TAB_KEY) {
            return;
        }
        const isChildElement = event.composedPath().includes(this.el);
        if (isChildElement) {
            return;
        }
        this.closeDropdown();
    };
    handleMouseLeave = () => {
        const focusedElementIsInsideDropDown = document.activeElement.closest("ch-dropdown") === this.el;
        if (focusedElementIsInsideDropDown) {
            this.expanded = true;
        }
        this.closeDropdownWithHover();
    };
    handleMouseEnter = () => {
        if (this.expandedWithHover) {
            return;
        }
        this.expandedWithHover = true;
        // If not previously expanded, emit the event
        if (!this.expanded) {
            this.expandedChange.emit(true);
        }
    };
    handleButtonClick = (event) => {
        event.stopPropagation();
        this.expandedChange.emit(!this.expanded);
        this.expanded = !this.expanded;
    };
    handleButtonFocus = (event) => {
        event.stopPropagation();
        if (this.expanded) {
            return;
        }
        this.expanded = true;
        // If not previously expanded, emit the event
        if (!this.expandedWithHover) {
            this.expandedChange.emit(true);
        }
    };
    componentWillLoad() {
        this.showHeader = !!this.el.querySelector(':scope > [slot="header"]');
        this.showFooter = !!this.el.querySelector(':scope > [slot="footer"]');
    }
    render() {
        const aligns = this.position.split("_");
        const alignX = aligns[0];
        const alignY = aligns[1];
        const xAlignMapping = mapDropdownAlignToChWindowAlign[alignX];
        const yAlignMapping = mapDropdownAlignToChWindowAlign[alignY];
        const isExpanded = this.expanded || this.expandedWithHover;
        this.firstExpanded ||= isExpanded;
        return (h(Host, { onMouseLeave: this.expandBehavior === "ClickOrHover"
                ? this.handleMouseLeave
                : undefined }, h("button", { id: EXPANDABLE_BUTTON_ID, "aria-controls": SECTION_ID, "aria-expanded": this.expanded.toString(), "aria-haspopup": "true", "aria-label": this.buttonLabel, class: "expandable-button", part: "expandable-button", type: "button", onClick: this.handleButtonClick, onFocus: this.openOnFocus ? this.handleButtonFocus : undefined, onMouseEnter: this.expandBehavior === "ClickOrHover"
                ? this.handleMouseEnter
                : undefined, ref: el => (this.expandableButton = el) }, h("slot", { name: "action" })), h("ch-window", { part: "window", exportparts: "window:section,mask,header,footer,separation", container: this.expandableButton, closeOnEscape: true, hidden: !isExpanded, modal: false, showFooter: this.showFooter, showHeader: this.showHeader, showMain: false,
            // Necessary since the separation between the button and the section
            // triggers the onMouseLeave event
            showSeparation: this.expandBehavior === "ClickOrHover", xAlign: xAlignMapping, yAlign: yAlignMapping }, this.firstExpanded && [
            this.showHeader && h("slot", { name: "header", slot: "header" }),
            h("div", { role: "list", class: "list", part: "list" }, h("slot", { name: "items" })),
            this.showFooter && h("slot", { name: "footer", slot: "footer" })
        ])));
    }
    static get is() { return "ch-dropdown"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dropdown.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dropdown.css"]
        };
    }
    static get properties() {
        return {
            "buttonLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This attribute lets you specify the label for the expandable button.\nImportant for accessibility."
                },
                "attribute": "button-label",
                "reflect": false,
                "defaultValue": "\"Show options\""
            },
            "expandBehavior": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"Click\" | \"ClickOrHover\"",
                    "resolved": "\"Click\" | \"ClickOrHover\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determine which actions on the expandable button display the dropdown\nsection."
                },
                "attribute": "expand-behavior",
                "reflect": false,
                "defaultValue": "\"ClickOrHover\""
            },
            "nestedDropdown": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This attribute lets you specify if the control is nested in another\ndropdown. Useful to manage keyboard interaction."
                },
                "attribute": "nested-dropdown",
                "reflect": false,
                "defaultValue": "false"
            },
            "openOnFocus": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determine if the dropdown section should be opened when the expandable\nbutton of the control is focused."
                },
                "attribute": "open-on-focus",
                "reflect": false,
                "defaultValue": "false"
            },
            "position": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "DropdownPosition",
                    "resolved": "\"Center_OutsideEnd\" | \"Center_OutsideStart\" | \"InsideEnd_OutsideEnd\" | \"InsideEnd_OutsideStart\" | \"InsideStart_OutsideEnd\" | \"InsideStart_OutsideStart\" | \"OutsideEnd_Center\" | \"OutsideEnd_InsideEnd\" | \"OutsideEnd_InsideStart\" | \"OutsideEnd_OutsideEnd\" | \"OutsideEnd_OutsideStart\" | \"OutsideStart_Center\" | \"OutsideStart_InsideEnd\" | \"OutsideStart_InsideStart\" | \"OutsideStart_OutsideEnd\" | \"OutsideStart_OutsideStart\"",
                    "references": {
                        "DropdownPosition": {
                            "location": "import",
                            "path": "./types",
                            "id": "src/components/dropdown/types.ts::DropdownPosition"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the position of the dropdown section that is placed relative to\nthe expandable button."
                },
                "attribute": "position",
                "reflect": false,
                "defaultValue": "\"Center_OutsideEnd\""
            }
        };
    }
    static get states() {
        return {
            "expanded": {},
            "expandedWithHover": {}
        };
    }
    static get events() {
        return [{
                "method": "expandedChange",
                "name": "expandedChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fired when the visibility of the dropdown section is changed"
                },
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "expanded",
                "methodName": "handleExpandedChange"
            }];
    }
    static get listeners() {
        return [{
                "name": "actionClick",
                "method": "handleActionClick",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "focusChange",
                "method": "handleDropDownItemFocusChange",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=dropdown.js.map
